/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrokerViewModel
 */
export interface BrokerViewModel {
    /**
     * 
     * @type {string}
     * @memberof BrokerViewModel
     */
    fSPName?: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerViewModel
     */
    fSPNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof BrokerViewModel
     */
    bankBrokerApplicationNumber?: number;
}

/**
 * Check if a given object implements the BrokerViewModel interface.
 */
export function instanceOfBrokerViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BrokerViewModelFromJSON(json: any): BrokerViewModel {
    return BrokerViewModelFromJSONTyped(json, false);
}

export function BrokerViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fSPName': !exists(json, 'FSPName') ? undefined : json['FSPName'],
        'fSPNumber': !exists(json, 'FSPNumber') ? undefined : json['FSPNumber'],
        'bankBrokerApplicationNumber': !exists(json, 'BankBrokerApplicationNumber') ? undefined : json['BankBrokerApplicationNumber'],
    };
}

export function BrokerViewModelToJSON(value?: BrokerViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FSPName': value.fSPName,
        'FSPNumber': value.fSPNumber,
        'BankBrokerApplicationNumber': value.bankBrokerApplicationNumber,
    };
}

